/* eslint-disable */
import React from "react";

import fig_1 from "./media/5-2-1.png";
import fig_2 from "./media/5-2-2.png";
import fig_3 from "./media/5-2-3.png";
import fig_4 from "./media/5-2-4.png";
import fig_5 from "./media/5-2-5.png";
import fig_7 from "./media/5-2-7.png";
import fig_8_1 from "./media/5-2-8-1.png";
import fig_8_2 from "./media/5-2-8-2.png";
import fig_8_3 from "./media/5-2-8-3.png";
import fig_8_4 from "./media/5-2-8-4.png";
import fig_9_1 from "./media/5-2-9-1.png";
import fig_9_2 from "./media/5-2-9-2-redrawn.png";
import fig_10 from "./media/5-2-10.png";
import fig_11 from "./media/5-2-11.png";
import fig_12_1 from "./media/5-2-12-1.png";
import fig_12_2 from "./media/5-2-12-2.png";
import fig_12_3 from "./media/5-2-12-3.png";
import fig_13_1 from "./media/5-2-13-1.png";
import fig_13_2 from "./media/5-2-13-2.png";
import fig_13_3 from "./media/5-2-13-3.png";
import fig_13_4 from "./media/5-2-13-4.png";
import fig_13_5 from "./media/5-2-13-5.png";
import fig_13_6 from "./media/5-2-13-6.png";
import fig_13_7 from "./media/5-2-13-7.png";
import fig_13_8 from "./media/5-2-13-8.png";
import fig_13_9 from "./media/5-2-13-9.png";
import fig_14_1 from "./media/5-2-14-1.png";
import fig_14_2 from "./media/5-2-14-2.png";
import fig_14_3 from "./media/5-2-14-3.png";
import fig_14_4 from "./media/5-2-14-4.png";
import fig_14_5 from "./media/5-2-14-5.png";
import fig_15_1 from "./media/5-2-15-1.png";
import fig_15_2 from "./media/5-2-15-2.png";
import fig_16 from "./media/5-2-16.png";
import table_1 from "./media/Table-5-2-1.png";
import scrollable_icon from "./media/scrollable_icon.png";
import penetrometer from "./media/penetrometer.png";
import slope_a_short from "./media/A_short.png";
import slope_a from "./media/A.png";
import slope_b from "./media/B.png";
import slope_c from "./media/C.png";

export const config = {
  mainMenu: ["Calculator", "Reference", "Links"],
  reference: [
    {
      bgPosition: "32vh",
      title: "INTRODUCTION",
      sections: [
        {
          type: "heading",
          body: "INTRODUCTION",
        },
        {
          type: "jsx",
          body: (
            <div>
              <p className="reference-body">
                Excavating is recognized as one of the most hazardous
                construction operations. OSHA revised Subpart P, Excavations, of
                29 CFR{" "}
                <a href="https://www.osha.gov/pls/oshaweb/owadisp.show_document?p_table=STANDARDS&p_id=10774">
                  1926.650
                </a>
                ,{" "}
                <a href="https://www.osha.gov/pls/oshaweb/owadisp.show_document?p_table=STANDARDS&p_id=10775">
                  .651
                </a>
                , and{" "}
                <a href="https://www.osha.gov/pls/oshaweb/owadisp.show_document?p_table=STANDARDS&p_id=10776">
                  .652
                </a>{" "}
                to make the standard easier to understand, permit the use of
                performance criteria where possible, and provide construction
                employers with options when classifying soil and selecting
                employee protection methods.
              </p>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "DEFINITIONS",
      sections: [
        {
          type: "heading",
          body: "DEFINITIONS",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">
                ACCEPTED ENGINEERING PRACTICES
              </p>
              <p className="gallery-text">
                {" "}
                are procedures compatible with the standards of practice
                required of a registered professional engineer.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">
                ADJACENT STRUCTURE STABILITY
              </p>
              <p className="gallery-text">
                {" "}
                refers to the stability of the foundation(s) of adjacent
                structures whose location may create surcharges, changes in soil
                conditions, or other disrauptions that have the potential to
                extend into the failure zone of the excavation or trench.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">COMPETENT PERSON</p>
              <p className="gallery-text">
                {" "}
                is an individual who is capable of identifying existing and
                predictable hazards or working conditions that are hazardous,
                unsanitary, or dangerous to employees, and who has authorization
                to take prompt corrective measures to eliminate or control these
                hazards and conditions.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">CONFINED SPACE</p>
              <p className="gallery-text">
                {" "}
                is a space that, by design and/or configuration, has limited
                openings for entry and exit, unfavorable natural ventilation,
                may contain or produce hazardous substances, and is not intended
                for continuous employee occupancy.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="big bold gallery-text">EXCAVATION</p>
              <p className="gallery-text">
                {" "}
                is any man-made cut, cavity, trench, or depression in an earth
                surface that is formed by earth removal. A{" "}
                <span className="bold">Trench</span> is a narrow excavation (in
                relation to its length) made below the surface of the ground. In
                general, the depth of a trench is greater than its width, and
                the width (measured at the bottom) is not greater than 15 ft
                (4.6 m). If a form or other structure installed or constructed
                in an excavation reduces the distance between the form and the
                side of the excavation to 15 ft (4.6 m) or less (measured at the
                bottom of the excavation), the excavation is also considered to
                be a trench.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">HAZARDOUS ATMOSPHERE</p>
              <p className="gallery-text">
                {" "}
                is an atmosphere that by reason of being explosive, flammable,
                poisonous, corrosive, oxidizing, irritating, oxygen-deficient,
                toxic, or otherwise harmful may cause death, illness, or injury
                to persons exposed to it.{" "}
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">ACCESS AND EGRESS</p>
              <p className="gallery-text">
                {" "}
                mean "entry" and "exit," respectively. In trenching and
                excavation operations, they refer to the provision of safe means
                for employees to enter or exit an excavation or trench.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">PROTECTIVE SYSTEM</p>
              <p className="gallery-text">
                {" "}
                refers to a method of protecting employees from cave-ins, from
                material that could fall or roll from an excavation face or into
                an excavation, and from the collapse of adjacent structures.
                Protective systems include support systems, sloping and benching
                systems, shield systems, and other systems that provide the
                necessary protection.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">
                REGISTERED PROFESSIONAL ENGINEER
              </p>
              <p className="gallery-text">
                {" "}
                is a person who is registered as a professional engineer in the
                state where the work is to be performed. However, a professional
                engineer who is registered in any state is deemed to be a
                "registered professional engineer" within the meaning of Subpart
                P when approving designs for "manufactured protective systems"
                or "tabulated data" to be used in interstate commerce.{" "}
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">SUPPORT SYSTEM</p>
              <p className="gallery-text">
                {" "}
                refers to structures such as underpinning, bracing, and shoring
                that provide support to an adjacent structure or underground
                installation or to the sides of an excavation or trench.{" "}
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">SURFACE ENCUMBRANCES</p>
              <p className="gallery-text">
                {" "}
                include foundations, utility poles, streams, fire hydrants,
                transformer vaults, and geological anomalies.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">SURCHARGE</p>
              <p className="gallery-text">
                {" "}
                means an excessive vertical load or weight caused by spoil,
                overburden, vehicles, equipment, or activities that may affect
                trench stability.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">TABULATED DATA</p>
              <p className="gallery-text">
                {" "}
                are tables and charts approved by a registered professional
                engineer and used to design and construct a protective system.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">UNDERGROUND INSTALLATIONS</p>
              <p className="gallery-text">
                {" "}
                include, but are not limited to, utilities (sewer, telephone,
                fuel, electric, water, and other product lines), tunnels,
                shafts, vaults, foundations, and other underground fixtures or
                equipment that may be encountered during excavation or trenching
                work.{" "}
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">
                UNCONFINED COMPRESSIVE STRENGTH
              </p>
              <p className="gallery-text">
                {" "}
                is the load per unit area at which soil will fail in
                compression. This measure can be determined by laboratory
                testing, or it can be estimated in the field using a pocket
                penetrometer, by thumb penetration tests, or by other methods.{" "}
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text scroll-item">
                  DEFINITIONS THAT ARE NO LONGER APPLICABLE
                </p>
                  <p className="">
                    For a variety of reasons, several terms commonly used in the
                    past are no longer used in revised Subpart P. These include
                    the following:
                  </p>
                <ol className="reference-list-number align-left">
                  <li>
                    <span className="bold">Angle of Repose</span> Conflicting
                    and inconsistent definitions have led to confusion as to the
                    meaning of this phrase. This term has been replaced by{" "}
                    <span className="bold">Maximum Allowable Slope.</span>
                  </li>
                  <li>
                    <span className="bold">Bank, Sheet Pile, and Walls</span>{" "}
                    Previous definitions were unclear or were used
                    inconsistently in the former standard.
                  </li>
                  <li>
                    <span className="bold">
                      Hard Compact Soil and Unstable Soil
                    </span>{" "}
                    The new soil classification system in revised Subpart P uses
                    different terms for these soil types.
                  </li>
                </ol>
              </div>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "SOIL MECHANICS",
      sections: [
        {
          type: "heading",
          body: "SOIL MECHANICS",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="big bold gallery-text">SOIL MECHANICS</p>
              <p className="gallery-text">
                A number of stresses and deformations can occur in an open cut
                or trench. For example, increases or decreases in moisture
                content can adversely affect the stability of a trench or
                excavation. The following diagrams show some of the more
                frequently identified causes of trench failure.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="gallery-text">
                <span className="bold">TENSION CRACKS.</span> Tension cracks
                usually form at a horizontal distance of 0.5 to 0.75 times the
                depth of the trench, measured from the top of the vertical face
                of the trench. See the accompanying drawing for additional
                details.
              </p>

              <p className="reference-figure-label">TENSION CRACK</p>
              <img alt="figure" className="reference-figure" src={fig_1} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="gallery-text">
                <span className="bold">SLIDING</span> or sluffing may occur as a
                result of tension cracks, as illustrated below.
              </p>

              <p className="reference-figure-label">SLIDING</p>
              <img alt="figure" className="reference-figure" src={fig_2} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="gallery-text">
                <span className="bold">TOPPLING.</span> In addition to sliding,
                tension cracks can cause toppling. Toppling occurs when the
                trench's vertical face shears along the tension crack line and
                topples into the excavation.
              </p>

              <p className="reference-figure-label">TOPPLING</p>
              <img alt="figure" className="reference-figure" src={fig_3} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="gallery-text">
                <span className="bold">SUBSIDENCE AND BULGING.</span> An
                unsupported excavation can create an unbalanced stress in the
                soil, which, in turn, causes subsidence at the surface and
                bulging of the vertical face of the trench. If uncorrected, this
                condition can cause face failure and entrapment of workers in
                the trench.
              </p>

              <p className="reference-figure-label">SUBSIDENCE AND BULGING</p>
              <img alt="figure" className="reference-figure" src={fig_4} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="gallery-text">
                <span className="bold">BOILING</span> is evidenced by an upward
                water flow into the bottom of the cut. A high water table is one
                of the causes of boiling. Boiling produces a "quick" condition
                in the bottom of the cut, and can occur even when shoring or
                trench boxes are used.
              </p>

              <p className="reference-figure-label">BOILING</p>
              <img alt="figure" className="reference-figure" src={fig_5} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="big bold gallery-text">UNIT WEIGHT OF SOILS</p>
              <p className="gallery-text">
                refers to the weight of one unit of a particular soil. The
                weight of soil varies with type and moisture content. One cubic
                foot of soil can weigh from 110 pounds to 140 pounds or more (1
                cubic yard = 27 cubic feet).
              </p>
            </div>
          ),
        },
      ],
    },

    {
      bgPosition: "45vh",
      title: "SOIL TYPES",
      sections: [
        {
          type: "heading",
          body: "SOIL TYPES",
        },

        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="gallery-text skinny">
                OSHA categorizes soil into four classifications: Stable Rock and
                Types A, B, and C.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="big bold gallery-text">STABLE ROCK</p>
              <p className="gallery-text">
                STABLE ROCK is natural solid mineral matter that can be
                excavated with vertical sides and remain intact while exposed.
                It is usually identified by a rock name such as granite or
                sandstone. Determining whether a deposit is of this type may be
                difficult unless it is known whether cracks exist and whether or
                not the cracks run into or away from the excavation.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="big bold gallery-text">TYPE A SOILS</p>
              <p className="gallery-text">
                TYPE A SOILS are cohesive soils with an unconfined compressive
                strength of 1.5 tons per square foot (tsf) (144 kPa) or greater.
                Examples of Type A cohesive soils are often: clay, silty clay,
                sandy clay, clay loam and, in some cases, silty clay loam and
                sandy clay loam. (No soil is Type A if it is fissured, is
                subject to vibration of any type, has previously been disturbed,
                is part of a sloped, layered system where the layers dip into
                the excavation on a slope of 4 horizontal to 1 vertical (4H:1V)
                or greater, or has seeping water.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="big bold gallery-text">TYPE B SOILS</p>
              <p className="gallery-text">
                TYPE B SOILS are cohesive soils with an unconfined compressive
                strength greater than 0.5 tsf (48 kPa) but less than 1.5 tsf
                (144 kPa). Examples of other Type B soils are: angular gravel;
                silt; silt loam; previously disturbed soils unless otherwise
                classified as Type C; soils that meet the unconfined compressive
                strength or cementation requirements of Type A soils but are
                fissured or subject to vibration; dry unstable rock; and layered
                systems sloping into the trench at a slope less than 4H:1V (only
                if the material would be classified as a Type B soil).
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="big bold gallery-text">TYPE C SOILS</p>
              <p className="gallery-text">
                TYPE C SOILS are cohesive soils with an unconfined compressive
                strength of 0.5 tsf (48 kPa) or less. Other Type C soils include
                granular soils such as gravel, sand and loamy sand, submerged
                soil, soil from which water is freely seeping, and submerged
                rock that is not stable. Also included in this classification is
                material in a sloped, layered system where the layers dip into
                the excavation or have a slope of four horizontal to one
                vertical (4H:1V) or greater.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">LAYERED GEOLOGICAL STRATA</p>
              <p className="gallery-text">
                Where soils are configured in layers, i.e., where a layered
                geologic structure exists, the soil must be classified on the
                basis of the soil classification of the weakest soil layer. Each
                layer may be classified individually if a more stable layer lies
                below a less stable layer, i.e., where a Type C soil rests on
                top of stable rock.
              </p>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "TEST EQUIPMENT & METHODS FOR EVALUATING SOIL TYPE",
      sections: [
        {
          type: "heading",
          body: "EVALUATING SOIL TYPE",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big gallery-text">
                {" "}
                Many kinds of equipment and methods are used to determine the
                type of soil prevailing in an area, as described in this
                section.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">POCKET PENETROMETER</p>
                <p>
                  <br />
                </p>
                <img
                  alt="figure"
                  className="reference-figure"
                  src={penetrometer}
                />
                  <p>
                    <span className="bold"></span> Penetrometers are
                    direct-reading, spring-operated instruments used to
                    determine the unconfined compressive strength of saturated
                    cohesive soils. Once pushed into the soil, an indicator
                    sleeve displays the reading. The instrument is calibrated in
                    either tons per square foot (tsf) or kilograms per square
                    centimeter (kPa). However, Penetrometers have error rates in
                    the range of ± 20-40%.{" "}
                  </p>

                <ol className="reference-list-number align-left">
                  <li>
                    <span className="bold">Shearvane (Torvane).</span> To
                    determine the unconfined compressive strength of the soil
                    with a shearvane, the blades of the vane are pressed into a
                    level section of undisturbed soil, and the torsional knob is
                    slowly turned until soil failure occurs. The direct
                    instrument reading must be multiplied by 2 to provide
                    results in tons per square foot (tsf) or kilograms per
                    square centimeter (kPa).
                  </li>
                  <li>
                    <span className="bold">Thumb Penetration Test.</span> The
                    thumb penetration procedure involves an attempt to press the
                    thumb firmly into the soil in question. If the thumb makes
                    an indentation in the soil only with great difficulty, the
                    soil is probably Type A. If the thumb penetrates no further
                    than the length of the thumb nail, it is probably Type B
                    soil, and if the thumb penetrates the full length of the
                    thumb, it is Type C soil. The thumb test is subjective and
                    is therefore the least accurate of the three methods.
                  </li>
                  <li>
                    <span className="bold">Dry Strength Test.</span> Dry soil
                    that crumbles freely or with moderate pressure into
                    individual grains is granular. Dry soil that falls into
                    clumps that subsequently break into smaller clumps (and the
                    smaller clumps can be broken only with difficulty) is
                    probably clay in combination with gravel, sand, or silt. If
                    the soil breaks into clumps that do not break into smaller
                    clumps (and the soil can be broken only with difficulty),
                    the soil is considered unfissured unless there is visual
                    indication of fissuring.
                  </li>
                </ol>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold gallery-text">
                PLASTICITY OR WET THREAD TEST
              </p>
              <p className="gallery-text">
                This test is conducted by molding a moist sample of the soil
                into a ball and attempting to roll it into a thin thread
                approximately 1/8 inch (3 mm) in diameter (thick) by 2 inches
                (50 mm) in length. The soil sample is held by one end. If the
                sample does not break or tear, the soil is considered cohesive.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <ol className="reference-list-number align-left">
                  <p className="big bold gallery-text">VISUAL TEST</p>
                  <p>
                    A visual test is a qualitative evaluation of conditions
                    around the site. In a visual test, the entire excavation
                    site is observed, including the soil adjacent to the site
                    and the soil being excavated. If the soil remains in clumps,
                    it is cohesive; if it appears to be coarse-grained sand or
                    gravel, it is considered granular. The evaluator also checks
                    for any signs of vibration.
                  </p>
                  <p>
                    During a visual test, the evaluator should check for
                    crack-line openings along the failure zone that would
                    indicate tension cracks, look for existing utilities that
                    indicate that the soil has previously been disturbed, and
                    observe the open side of the excavation for indications of
                    layered geologic structuring.
                  </p>
                  <p>
                    The evaluator should also look for signs of bulging,
                    boiling, or sluffing, as well as for signs of surface water
                    seeping from the sides of the excavation or from the water
                    table. If there is standing water in the cut, the evaluator
                    should check for "quick" conditions (see{" "}
                    <a href="https://www.osha.gov/dts/osta/otm/otm_v/otm_v_2.html#iii_f">
                      Paragraph III. F. on OSHA's website
                    </a>
                    ). In addition, the area adjacent to the excavation should
                    be checked for signs of foundations or other intrusions into
                    the failure zone, and the evaluator should check for
                    surcharging and the spoil distance from the edge of the
                    excavation.
                  </p>
                </ol>
              </div>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "SHORING TYPES",
      sections: [
        {
          type: "heading",
          body: "SHORING TYPES",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="gallery-text">
                Shoring is the provision of a support system for trench faces
                used to prevent movement of soil, underground utilities,
                roadways, and foundations. Shoring or shielding is used when the
                location or depth of the cut makes sloping back to the maximum
                allowable slope impractical. Shoring systems consist of posts,
                wales, struts, and sheeting. There are two basic types of
                shoring, timber and aluminum hydraulic.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">TIMBER SHORING</p>
              <img alt="figure" className="reference-figure" src={fig_7} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                  <p className="big bold gallery-text">HYDRAULIC SHORING</p>
                  <p className="">
                    The trend today is toward the use of hydraulic shoring, a
                    prefabricated strut and/or wale system manufactured of
                    aluminum or steel.
                  </p>
                  <p>
                    Hydraulic shoring provides a critical safety advantage over
                    timber shoring because workers do not have to enter the
                    trench to install or remove hydraulic shoring. Other
                    advantages of most hydraulic systems are that they:
                  </p>
                <ul className="reference-list-number align-left">
                  <li>Are light enough to be installed by one worker;</li>
                  <li>
                    Are gauge-regulated to ensure even distribution of pressure
                    along the trench line;
                  </li>
                  <li>
                    Can have their trench faces "preloaded" to use the soil's
                    natural cohesion to prevent movement; and
                  </li>
                  <li>
                    Can be adapted easily to various trench depths and widths.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="gallery-text skinny">
                All shoring should be installed from the top down and removed
                from the bottom up. Hydraulic shoring should be checked at least
                once per shift for leaking hoses and/or cylinders, broken
                connections, cracked nipples, bent bases, and any other damaged
                or defective parts.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">
                VERTICAL ALUMINUM HYDRAULIC SHORING (SPOT BRACING)
              </p>
              <img alt="figure" className="reference-figure" src={fig_8_1} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">
                VERTICAL ALUMINUM HYDRAULIC SHORING (WITH PLYWOOD)
              </p>
              <img alt="figure" className="reference-figure" src={fig_8_2} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">
                VERTICAL ALUMINUM HYDRAULIC SHORING (STACKED)
              </p>
              <img alt="figure" className="reference-figure" src={fig_8_3} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">
                ALUMINUM HYDRAULIC SHORING WALER SYSTEM (TYPICAL)
              </p>
              <img alt="figure" className="reference-figure" src={fig_8_4} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                  <p className="big bold gallery-text">PNEUMATIC SHORING</p>
                  <p className="skinny">
                    <span className="bold">PNEUMATIC SHORING</span> works in a
                    manner similar to hydraulic shoring. The primary difference
                    is that pneumatic shoring uses air pressure in place of
                    hydraulic pressure. A disadvantage to the use of pneumatic
                    shoring is that an air compressor must be on site.
                  </p>
                <ul className="reference-list-number align-left">
                  <li>
                    <span className="bold">Screw Jacks.</span> Screw jack
                    systems differ from hydraulic and pneumatic systems in that
                    the struts of a screw jack system must be adjusted manually.
                    This creates a hazard because the worker is required to be
                    in the trench in order to adjust the strut. In addition,
                    uniform "preloading" cannot be achieved with screw jacks,
                    and their weight creates handling difficulties.
                  </li>
                  <li>
                    <span className="bold">
                      Single-Cylinder Hydraulic Shores.
                    </span>{" "}
                    Shores of this type are generally used in a water system, as
                    an assist to timber shoring systems, and in shallow trenches
                    where face stability is required.
                  </li>
                  <li>
                    <span className="bold">Underpinning.</span> This process
                    involves stabilizing adjacent structures, foundations, and
                    other intrusions that may have an impact on the excavation.
                    As the term indicates, underpinning is a procedure in which
                    the foundation is physically reinforced. Underpinning should
                    be conducted only under the direction and with the approval
                    of a registered professional engineer.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">SHORING VARIATIONS</p>
              <img alt="figure" className="reference-figure" src={fig_9_1} />
            </div>
          ),
          header: "SHORING VARIATIONS",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <img alt="figure" className="reference-figure" src={fig_9_2} />
            </div>
          ),
          header: "SHORING VARIATIONS",
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "SHIELDING TYPES",
      sections: [
        {
          type: "heading",
          body: "SHIELDING TYPES",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="gallery-text">
                <span className="bold">TRENCH BOXES</span> are different from
                shoring because, instead of shoring up or otherwise supporting
                the trench face, they are intended primarily to protect workers
                from cave-ins and similar incidents. The excavated area between
                the outside of the trench box and the face of the trench should
                be as small as possible. The space between the trench boxes and
                the excavation side are backfilled to prevent lateral movement
                of the box. Shields may not be subjected to loads exceeding
                those which the system was designed to withstand.
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">TRENCH SHIELD</p>
              <img alt="figure" className="reference-figure" src={fig_10} />
            </div>
          ),
          header: "SHORING VARIATIONS",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder tall">
              <p className="reference-figure-label">TRENCH SHIELD, STACKED</p>
              <img alt="figure" className="reference-figure" src={fig_11} />
            </div>
          ),
          header: "SHORING VARIATIONS",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                
                  <p className="align-left">
                    <span className="bold">COMBINED USE. </span> Trench boxes
                    are generally used in open areas, but they also may be used
                    in combination with sloping and benching. The box should
                    extend at least 18 in (0.45 m) above the surrounding area if
                    there is sloping toward excavation. This can be accomplished
                    by providing a benched area adjacent to the box.{" "}
                  </p>
                  <p className="align-left">
                    Earth excavation to a depth of 2 ft (0.61 m) below the
                    shield is permitted, but only if the shield is designed to
                    resist the forces calculated for the full depth of the
                    trench and there are no indications while the trench is open
                    of possible loss of soil from behind or below the bottom of
                    the support system. Conditions of this type require
                    observation on the effects of bulging, heaving, and boiling
                    as well as surcharging, vibration, adjacent structures,
                    etc., on excavating below the bottom of a shield. Careful
                    visual inspection of the conditions mentioned above is the
                    primary and most prudent approach to hazard identification
                    and control.{" "}
                  </p>
                
              </div>
            </div>
          ),
        },
        // {
        //     type: 'jsx',
        //     body: <div className="gallery-item-holder">
        //         <div className="reference-figure-holder">
        //             <p className="reference-figure-label">SLOPE AND SHIELD CONFIGURATIONS</p>
        //             <img alt="figure" className="reference-figure" src={fig_12_1} />
        //         </div>
        //     </div>,
        //     header: 'SLOPE AND SHIELD CONFIGURATIONS',
        // },
        // {
        //     type: 'jsx',
        //     body: <div className="gallery-item-holder">
        //         <div className="reference-figure-holder">
        //             <p className="reference-figure-label">SLOPE AND SHIELD CONFIGURATIONS</p>
        //             <img alt="figure" className="reference-figure" src={fig_12_2} />
        //         </div>
        //     </div>,
        //     header: 'SLOPE AND SHIELD CONFIGURATIONS',
        // },
        // {
        //     type: 'jsx',
        //     body: <div className="gallery-item-holder">
        //         <div className="reference-figure-holder">
        //             <p className="reference-figure-label">SLOPE AND SHIELD CONFIGURATIONS</p>
        //             <img alt="figure" className="reference-figure" src={fig_12_3} />
        //         </div>
        //     </div>,
        //     header: 'SLOPE AND SHIELD CONFIGURATIONS',
        // },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="reference-figure-label">
                  SLOPE AND SHIELD CONFIGURATIONS
                </p>
                <img alt="figure" className="reference-figure" src={fig_12_1} />
                <img alt="figure" className="reference-figure" src={fig_12_2} />
                <img alt="figure" className="reference-figure" src={fig_12_3} />
              </div>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "SLOPING & BENCHING",
      sections: [
        {
          type: "heading",
          body: "SLOPING & BENCHING",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="gallery-text">
                <span className="bold">SLOPING.</span> Maximum allowable slopes
                for excavations less than 20 ft (6.09 m) based on soil type and
                angle to the horizontal are as follows:
              </p>

              <img alt="figure" className="reference-figure" src={table_1} />
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="reference-figure-label">
                  SLOPE CONFIGURATIONS: EXCAVATIONS IN LAYERED SOILS
                </p>
                <img alt="figure" className="reference-figure" src={fig_13_1} />
                <img alt="figure" className="reference-figure" src={fig_13_2} />
                <img alt="figure" className="reference-figure" src={fig_13_3} />
                <img alt="figure" className="reference-figure" src={fig_13_4} />
                <img alt="figure" className="reference-figure" src={fig_13_5} />
                <img alt="figure" className="reference-figure" src={fig_13_6} />
                <img alt="figure" className="reference-figure" src={fig_13_7} />
                <img alt="figure" className="reference-figure" src={fig_13_8} />
                <img alt="figure" className="reference-figure" src={fig_13_9} />
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="reference-figure-label">
                  EXCAVATIONS MADE IN TYPE A SOIL
                </p>
                <img alt="figure" className="reference-figure" src={fig_14_1} />
                <img alt="figure" className="reference-figure" src={fig_14_2} />
                <img alt="figure" className="reference-figure" src={fig_14_3} />
                <img alt="figure" className="reference-figure" src={fig_14_4} />
                <img alt="figure" className="reference-figure" src={fig_14_5} />
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="reference-figure-label">
                  EXCAVATIONS MADE IN TYPE B SOIL
                </p>
                <img alt="figure" className="reference-figure" src={fig_15_1} />
                <img alt="figure" className="reference-figure" src={fig_15_2} />
              </div>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "SPOIL",
      sections: [
        {
          type: "heading",
          body: "OVERVIEW: SPOIL",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                  <p className="align-left">
                    <span className="bold">TEMPORARY SPOIL</span> must be placed
                    no closer than 2 ft (0.61 m) from the surface edge of the
                    excavation, measured from the nearest base of the spoil to
                    the cut.
                  </p>
                  <p className="align-left">
                    This distance should not be measured from the crown of the
                    spoil deposit. This distance requirement ensures that loose
                    rock or soil from the temporary spoil will not fall on
                    employees in the trench.
                  </p>
                  <p className="align-left">
                    Spoil should be placed so that it channels rainwater and
                    other run-off water away from the excavation. Spoil should
                    be placed so that it cannot accidentally run, slide, or fall
                    back into the excavation.
                  </p>
                <p className="reference-figure-label">TEMPORARY SPOIL</p>
                <img alt="figure" className="reference-figure" src={fig_16} />
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="gallery-text">
                <span className="bold">PERMANENT SPOIL</span> should be placed
                at some distance from the excavation. Permanent spoil is often
                created where underpasses are built or utilities are buried. The
                improper placement of permanent spoil, i.e. insufficient
                distance from the working excavation, can cause an excavation to
                be out of compliance with the horizontal-to-vertical ratio
                requirement for a particular excavation.
              </p>
              <p>
                This can usually be determined through visual observation.
                Permanent spoil can change undisturbed soil to daisturbed soil
                and dramatically alter slope requirements.{" "}
              </p>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "SPECIAL HEALTH & SAFETY CONSIDERATIONS",
      sections: [
        {
          type: "heading",
          body: "HEALTH & SAFETY",
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">COMPETENT PERSON</p>
                <p className="gallery-text">
                  The designated competent person should have and be able to
                  demonstrate the following:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    <p>Training, experience, and knowledge of:</p>
                    <ul>
                      <li>soil analysis;</li>
                      <li>use of protective systems; and</li>
                      <li>
                        requirements of{" "}
                        <a href="https://www.osha.gov/pls/oshaweb/owastand.display_standard_group?p_toc_level=1&p_part_number=1926">
                          29 CFR Part 1926 Subpart P.
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="align-left">
                    <p>Ability to detect:</p>
                    <ul>
                      <li>conditions that could result in cave-ins;</li>
                      <li>failures in protective systems;</li>
                      <li>hazardous atmospheres; and</li>
                      <li>
                        other hazards including those associated with confined
                        spaces.
                      </li>
                    </ul>
                  </li>
                  <li className="align-left">
                    <p>
                      Authority to take prompt corrective measures to eliminate
                      existing and predictable hazards and to stop work when
                      required.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">
                  SURFACE CROSSING OF TRENCHES
                </p>
                <p className="gallery-text">
                  Surface crossing of trenches should be discouraged; however,
                  if trenches must be crossed, such crossings are permitted only
                  under the following conditions:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Vehicle crossings must be designed by and installed under
                    the supervision of a registered professional engineer.
                  </li>
                  <li className="align-left">
                    <p>
                      Walkways or bridges must be provided for foot traffic.
                      These structures shall:
                    </p>
                    <ul>
                      <li>have a safety factor of 4;</li>
                      <li>have a minimum clear width of 20 in (0.51 m);</li>
                      <li>be fitted with standard rails; and</li>
                      <li>
                        extend a minimum of 24 in (.61 m) past the surface edge
                        of the trench.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">ACCESS AND EGRESS</p>
                <p className="gallery-text skinny">
                  Access to and exit from the trench require the following
                  conditions:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Trenches 4 ft or more in depth should be provided with a
                    fixed means of egress.
                  </li>
                  <li className="align-left">
                    Spacing between ladders or other means of egress must be
                    such that a worker will not have to travel more than 25 ft
                    laterally to the nearest means of egress.
                  </li>
                  <li className="align-left">
                    Ladders must be secured and extend a minimum of 36 in (0.9
                    m) above the landing.
                  </li>
                  <li className="align-left">
                    Metal ladders should be used with caution, particularly when
                    electric utilities are present.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">EXPOSURE TO VEHICLES</p>
                <p className="gallery-text skinny">
                  Procedures to protect employees from being injured or killed
                  by vehicle traffic include:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Providing employees with and requiring them to wear warning
                    vests or other suitable garments marked with or made of
                    reflectorized or high-visibility materials.
                  </li>
                  <li className="align-left">
                    Requiring a designated, trained flagperson along with signs,
                    signals, and barricades when necessary.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">
                  EXPOSURE TO FALLING LOADS
                </p>
                <p className="gallery-text skinny">
                  Employees must be protected from loads or objects falling from
                  lifting or digging equipment. Procedures designed to ensure
                  their protection include:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    <p>
                      Employees are not permitted to work under raised loads.
                    </p>
                  </li>
                  <li className="align-left">
                    Employees are required to stand away from equipment that is
                    being loaded or unloaded.
                  </li>
                  <li className="align-left">
                    Equipment operators or truck drivers may stay in their
                    equipment during loading and unloading if the equipment is
                    properly equipped with a cab shield or adequate canopy.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">
                  WARNING SYSTEMS FOR MOBILE EQUIPMENT
                </p>
                <p className="gallery-text skinny">
                  The following steps should be taken to prevent vehicles from
                  accidentally falling into the trench:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Barricades must be installed where necessary.
                  </li>
                  <li className="align-left">
                    Hand or mechanical signals must be used as required.
                  </li>
                  <li className="align-left">
                    Stop logs must be installed if there is a danger of vehicles
                    falling into the trench.
                  </li>
                  <li className="align-left">
                    Soil should be graded away from the excavation; this will
                    assist in vehicle control and channeling of run-off water.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">
                  HAZARDOUS ATMOSPHERES AND CONFINED SPACES.
                </p>
                <p className="gallery-text skinny">
                  Employees shall not be permitted to work in hazardous and/or
                  toxic atmospheres. Such atmospheres include those with:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Less than 19.5% or more than 23.5% oxygen;
                  </li>
                  <li className="align-left">
                    A combustible gas concentration greater than 10% of the
                    lower explosive limit (LEL); and
                  </li>
                  <li className="align-left">
                    Concentrations of hazardous substances that exceed those
                    specified in the Threshold Limit Values for Airborne
                    Contaminants established by the ACGIH (American Conference
                    of Governmental Industrial Hygienists).
                  </li>
                </ul>
                <p className="gallery-text">
                  All operations involving such atmospheres must be conducted in
                  accordance with OSHA requirements for occupational health and
                  environmental controls (see{" "}
                  <a href="https://www.osha.gov/pls/oshaweb/owastand.display_standard_group?p_toc_level=1&p_part_number=1926">
                    Subpart D of 29 CPR 1926
                  </a>
                  ) for personal protective equipment and for lifesaving
                  equipment (see{" "}
                  <a href="https://www.osha.gov/pls/oshaweb/owastand.display_standard_group?p_toc_level=1&p_part_number=1926">
                    Subpart E, 29 CFR 1926
                  </a>
                  ). Engineering controls (e.g., ventilation) and respiratory
                  protection may be required.
                </p>
                <p className="gallery-text">
                  When testing for atmospheric contaminants, the following
                  should be considered:{" "}
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Testing should be conducted before employees enter the
                    trench and should be done continuously to ensure that the
                    trench remains safe.
                  </li>
                  <li className="align-left">
                    The frequency of testing should be increased if equipment is
                    operating in the trench or if welding, cutting, or burning
                    is done in the trench.
                  </li>
                </ul>
                <p className="gallery-text">
                  Employees required to wear respiratory protection must be
                  trained, fit-tested, and enrolled in a respiratory protection
                  program. Some trenches qualify as confined spaces. When this
                  occurs, compliance with the Confined Space Standard is also
                  required.
                </p>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">
                  EMERGENCY RESCUE EQUIPMENT
                </p>
                <p className="gallery-text skinny">
                  Emergency rescue equipment is required when a hazardous
                  atmosphere exists or can reasonably be expected to exist.
                  Requirements are as follows:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Respirators must be of the type suitable for the exposure.
                    Employees must be trained in their use and a respirator
                    program must be instituted.
                  </li>
                  <li className="align-left">
                    Attended (at all times) lifelines must be provided when
                    employees enter bell-bottom pier holes, deep confined
                    spaces, or other similar hazards.
                  </li>
                  <li className="align-left">
                    Employees who enter confined spaces must be trained.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">
                  STANDING WATER AND WATER ACCUMULATION
                </p>
                <p className="gallery-text skinny">
                  Methods for controlling standing water and water accumulation
                  must be provided and should consist of the following if
                  employees are permitted to work in the excavation:{" "}
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Use of special support or shield systems approved by a
                    registered professional engineer.
                  </li>
                  <li className="align-left">
                    Dewatering equipment and dewatering operations must be
                    monitored by a competent person.
                  </li>
                  <li className="align-left">
                    Safety harnesses and lifelines used in conformance with{" "}
                    <a href="https://www.osha.gov/pls/oshaweb/owadisp.show_document?p_table=STANDARDS&p_id=9750">
                      29 CFR 1926.104
                    </a>{" "}
                    and{" "}
                    <a href="https://www.osha.gov/pls/oshaweb/owadisp.show_document?p_table=STANDARDS&p_id=10756">
                      29 CFR Subpart M.
                    </a>
                  </li>
                  <li className="align-left">
                    Surface water diverted away from the trench
                  </li>
                  <li className="align-left">
                    Employees removed from the trench during rainstorms.
                  </li>
                  <li className="align-left">
                    Trenches carefully inspected by a competent person after
                    each rain and before employees are permitted to re-enter the
                    trench.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder scroll">
              <div className="height-50vh vertical-scroll">
                <p className="big bold gallery-text">INSPECTIONS</p>
                <p className="gallery-text skinny">
                  Inspections shall be made by a competent person and should be
                  documented. The following guide specifies the frequency and
                  conditions requiring inspections:
                </p>
                <ul className="align-left">
                  <li className="align-left">
                    Daily and before the start of each shift;
                  </li>
                  <li className="align-left">After every rainstorm;</li>
                  <li className="align-left">
                    After other events that could increase hazards, e.g.
                    snowstorm;
                  </li>
                  <li className="align-left">
                    When fissures, tension cracks, sloughing, undercutting,
                    water seepage, bulging at the bottom, or other similar
                    conditions occur;
                  </li>
                  <li className="align-left">
                    When there is a change in the size, location, or placement
                    of the spoil pile; and
                  </li>
                  <li className="align-left">
                    When there is any indication of change or movement in
                    adjacent structures.
                  </li>
                </ul>
              </div>
            </div>
          ),
        },
      ],
    },
    {
      bgPosition: "45vh",
      title: "SITE ASSESSMENT",
      sections: [
        {
          type: "heading",
          body: "SITE ASSESSMENT QUESTIONS",
        },
        // {
        //     type: 'jsx',
        //     body: <div className="gallery-item-holder">
        //         <p className="gallery-text skinny">During first and subsequent visits to a construction location, the competent person should consider the following issues and ensure that appropriate safety plans are in place to permit safe and healthful performance of work activities. </p>
        //     </div>,
        // },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="gallery-text">
                During first and subsequent visits to a construction location,
                the competent person should consider the following issues and
                ensure that appropriate safety plans are in place to permit safe
                and healthful performance of work activities.{" "}
              </p>
              <p className="big bold number">1</p>
              <p className="gallery-text skinny center">
                Is the cut, cavity, or depression a <em>trench</em> or an{" "}
                <em>excavation?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">2</p>
              <p className="gallery-text skinny center">
                Is the cut, cavity, or depression more than 4 ft (1.2 m) in{" "}
                <em>depth?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">3</p>
              <p className="gallery-text skinny center">
                Is there <em>water</em> in the cut, cavity, or depression?
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">4</p>
              <p className="gallery-text skinny center">
                Are there adequate means of <em>access</em> and <em>egress?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">5</p>
              <p className="gallery-text skinny center">
                Are there any surface <em>encumbrances?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">6</p>
              <p className="gallery-text skinny center">
                Is there exposure to <em>vehicular traffic? </em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">7</p>
              <p className="gallery-text skinny center">
                Are <em>adjacent structures stabilized?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">8</p>
              <p className="gallery-text skinny center">
                Does <em>mobile equipment</em> have a <em>warning system?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">9</p>
              <p className="gallery-text skinny center">
                Is a <em>competent person</em> in charge of the operation?
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">10</p>
              <p className="gallery-text skinny center">
                Is <em>equipment</em> operating in or around the cut, cavity, or
                depression?
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">11</p>
              <p className="gallery-text skinny center">
                Are procedures required to monitor, test, and{" "}
                <em>control hazardous atmospheres?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">12</p>
              <p className="gallery-text skinny center">
                Does a competent person <em>determine soil type?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">13</p>
              <p className="gallery-text skinny center">
                Was a <em>soil testing device</em> used to determine soil type?{" "}
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">14</p>
              <p className="gallery-text skinny center">
                Is the <em>spoil</em> placed 2 ft (0.6 m) or more from the edge
                of the cut, cavity, or depression?
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">15</p>
              <p className="gallery-text skinny center">
                Is the <em>depth</em> 20 ft (6.1 m) or <em>more</em> for the
                cut, cavity, or depression?
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">16</p>
              <p className="gallery-text skinny center">
                Has a <em>registered professional engineer</em> approved the
                procedure if the depth is more than 20 ft (6.1 m)?
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">17</p>
              <p className="gallery-text skinny center">
                Does the procedure require{" "}
                <em>benching or multiple benching? Shoring? Shielding?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">18</p>
              <p className="gallery-text skinny center">
                If provided,{" "}
                <em>do shields extend at least 18 in (0.5 m) above</em> the
                surrounding area if it is sloped toward the excavation?{" "}
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">19</p>
              <p className="gallery-text skinny center">
                If shields are used, is the depth of the cut{" "}
                <em>more than 2 ft (0.6 m) below the bottom of the shield?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">20</p>
              <p className="gallery-text skinny center">
                Are any required surface crossings of the cut, cavity, or
                depression the <em>proper width and fitted with hand rails?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">21</p>
              <p className="gallery-text skinny center">
                Are means of egress from the cut, cavity, or depression{" "}
                <em>no more than 25 ft (7.6m) from the work?</em>
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">22</p>
              <p className="gallery-text skinny center">
                Is <em>emergency rescue equipment</em> required?
              </p>
            </div>
          ),
        },
        {
          type: "jsx",
          body: (
            <div className="gallery-item-holder">
              <p className="big bold number">23</p>
              <p className="gallery-text skinny center">
                Is there{" "}
                <em>
                  documentation of the minimum daily excavation inspection?{" "}
                </em>
              </p>
            </div>
          ),
        },
      ],
    },
  ],
  calculators: [
    {
      soil: "Type A Soil",
      img: slope_a,
      minimum: 4,
      depth: [
        // {
        //     max: 12,
        //     angle: 0.5,
        //     ratio: '1/2:1',
        //     slope: '63°',
        // },
        {
          max: 20,
          angle: 0.75,
          ratio: "3/4:1",
          slope: "53°",
          img: slope_a,
        },
      ],
    },
    {
      soil: "Type B Soil",
      img: slope_b,
      minimum: 4,
      depth: [
        {
          max: 20,
          angle: 1,
          ratio: "1:1",
          slope: "45°",
          img: slope_b,
        },
      ],
    },
    {
      soil: "Type C Soil",
      img: slope_c,
      minimum: 4,
      depth: [
        {
          max: 20,
          angle: 1.5,
          ratio: "1 1/2:1",
          slope: "34°",
          img: slope_c,
        },
      ],
    },
    {
      soil: "Type A (Short-Term)",
      img: slope_a_short,
      minimum: 4,
      depth: [
        {
          max: 12,
          angle: 0.5,
          ratio: "1/2:1",
          slope: "63°",
          img: slope_a_short,
        },
        {
          max: 20,
          angle: 0.75,
          ratio: "3/4:1",
          slope: "53°",
          img: slope_a,
        },
      ],
    },
    // {
    //     soil: 'Stable Rock',
    //     minimum: 0,
    //     depth: [
    //         {
    //             max: 20,
    //             angle: 0,
    //             ratio: 'Vertical',
    //             slope: '90°',
    //         }
    //     ]
    //
    // }
  ],
  links: [
    {
      title: "OSHA 29 CFR Part 1926 Subpart P",
      href: "https://www.osha.gov/pls/oshaweb/owadisp.show_document?p_table=STANDARDS&p_id=10930",
    },
    {
      title: "Army Corps of Engineers Excavation & Trenching",
      href: "https://drive.google.com/file/d/1hatxkVbY3bPNZ6D-2JPIW9df5kxFTNiC/view?usp=sharing",
    },
  ],
};

// WEBPACK FOOTER //
// ./src/config.js
